import graphql from "babel-plugin-relay/macro";

import { useMutationWithError } from "../../../../../../../utils/hooks/useMutationWithError";
import { useCreateEmailVerificationNotificationsMutation } from "./__generated__/useCreateEmailVerificationNotificationsMutation.graphql";

export const useCreateEmailVerificationNotifications = () => {
  const [createVerification, isCreating] =
    useMutationWithError<useCreateEmailVerificationNotificationsMutation>(
      useCreateEmailVerificationNotificationsMutationString
    );

  const createEmailVerification = (
    email: string,
    onCompleteHandler: () => void
  ) => {
    createVerification({
      variables: { input: { email } },
      onCompleted: (res) => {
        if (res.responsePayload?.success) {
          onCompleteHandler();
        }
      },
    });
  };
  return [createEmailVerification, isCreating] as const;
};

export const useCreateEmailVerificationNotificationsMutationString = graphql`
  mutation useCreateEmailVerificationNotificationsMutation(
    $input: CreateEmailVerificationInput!
  ) {
    responsePayload: createEmailVerification(input: $input) {
      success
      errors {
        field
        code
        message
      }
    }
  }
`;
